import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { IState } from './invoice-data.reducer';
import { DocumentDataDispatcher } from '../document-data/document-data.dispatcher';
import { Invoice } from './invoice.model';
import { InvoiceDataStore } from './invoice-data.store';
import { InvoiceDataBuilder } from './invoice-data.builder';
import { IInvoiceDataDispatcher } from './invoice-data-dispatcher.interface';
import {
  IAddManualPayment,
  IMarkAsPaidData,
} from '../payments-data/payments-data.data';
import {
  createManualPayment,
  deleteManualPayment,
  deleteSchedule,
  markAsPaid,
  markSelectedInvoicesAsPaid,
  refundEPayment,
  unmatchTransaction,
  updateSchedule,
} from './invoice-data.actions';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { Map } from 'immutable';
import { PaymentTransaction } from '../document-data/sub-models/payment-transaction.model';
import { v4 } from 'uuid';
import { Observable } from 'rxjs';

@Injectable()
export class InvoiceDataDispatcher
  extends DocumentDataDispatcher<IState, Invoice>
  implements IInvoiceDataDispatcher {
  constructor(
    store: Store<any>,
    invoiceDataStore: InvoiceDataStore,
    settingsDataStore: SettingsDataStore,
    invoiceDataBuilder: InvoiceDataBuilder,
    globalBannerService: GlobalBannerService,
    translateService: TranslateService
  ) {
    super(
      store,
      invoiceDataStore,
      settingsDataStore,
      invoiceDataBuilder,
      globalBannerService,
      translateService
    );
  }

  createManualPayment(
    addManualPaymentData: IAddManualPayment,
    setEditingEntity?: boolean
  ): Observable<Invoice> {
    const dispatchId = v4();

    this.store.dispatch(
      createManualPayment(
        dispatchId,
        this.entityType,
        addManualPaymentData,
        setEditingEntity
      )
    );

    return this.documentDataStore.getDispatchedResponse<Invoice>(dispatchId);
  }

  deleteManualPayment(paymentTransaction: PaymentTransaction) {
    this.store.dispatch(
      deleteManualPayment(this.entityType, paymentTransaction)
    );
  }

  markAsPaid(
    documentId: string,
    markAsPaidData?: IMarkAsPaidData,
    setEditingEntity?: boolean
  ) {
    this.store.dispatch(
      markAsPaid(this.entityType, documentId, markAsPaidData, setEditingEntity)
    );
  }

  refundEPayment(transactionId: string) {
    this.store.dispatch(refundEPayment(this.entityType, transactionId));
  }

  unmatchTransaction(transactionId: string) {
    this.store.dispatch(unmatchTransaction(this.entityType, transactionId));
  }

  markSelectedInvoicesAsPaid(listFilter?: string) {
    this.store.dispatch(
      markSelectedInvoicesAsPaid(this.entityType, listFilter)
    );
  }

  updateSchedule(documentId: string, properties: Map<string, any>) {
    this.store.dispatch(
      updateSchedule(this.entityType, documentId, properties)
    );
  }

  deleteSchedule(documentId: string) {
    this.store.dispatch(deleteSchedule(this.entityType, documentId));
  }
}
